import GalleryPlaceholder from "csi/gallery/GalleryPlaceholder";
import Widget from "csi/html/Widget";
import locale from "csi/locale";
import declare from "dojo/_base/declare";

export = declare(Widget, {

	/**
	 * @override
	 * If the user does not have access to the document revision,
	 * show a placeholder stating that the user does not have permission.
	 */
	onViewCreate() {
		const c8Instance = this.cacheView.getPathNode(this.urlRoot, "Child:C8Instance");
		if (!c8Instance) {
			new GalleryPlaceholder({
				titleText: locale.resource("MissingPermissions"),
				description: locale.resource("ProofingPermissionMissing"),
			})
				.placeAt(this.domNode);
		}
	},
});
